const { julho_14: Julho14 } = window.SIMBAR;

export const GROUP_NAME = Julho14.group;
export const SOURCE = Julho14.source;
export const HOME_ROUTE_NAME = "julho_14";
export const TITLE = "14 de Julho";
export const SENSOR_UNITS = Julho14.sensor_units;
export const SENSOR_LABELS = Julho14.sensor_labels;
export const SPECIAL_PERMISSIONS = Julho14.special_permissions;
export const RTS_IMAGE = require("@/assets/images/julho_14/rts_labeled_reduced.png");
